module.exports = __webpack_public_path__ + "static/media/oasis1.057c0272.jpg";